import React from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Text,
  Box,
} from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";

export default function DeleteEventDialogComponent({ id, title, deleteEvent }) {
  const [isOpen, setIsOpen] = React.useState(false);

  const onClose = () => {
    setIsOpen(false);
  };

  const deleteCurrent = () => {
    setIsOpen(false);
    deleteEvent(id);
  };
  const cancelRef = React.useRef();

  return (
    <>
      <Button
        borderRadius={"full"}
        paddingInline={4}
        w={["100%", "100%", "31%", "31%"]}
        color="white"
        backgroundColor="#FF0010"
        onClick={() => setIsOpen(true)}
      >
        Supprimer
      </Button>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent
            fontFamily={"Sofia Pro"}
            textAlign={"center"}
            bg="#D4EEFF"
            borderRadius={20}
            padding={"40px"}
            width={"100%"}
            isCentered
          >
            <AlertDialogHeader
              fontSize="lg"
              fontFamily={"Sofia Pro"}
              fontWeight="bold"
              textAlign={"center"}
            >
              Supprimer l’événement
            </AlertDialogHeader>

            <AlertDialogBody>
              <Box bg={"#0080FF"} color={"white"} borderRadius={25} p={"20px"}>
                Etes-vous sûr de vouloir supprimer l’événement "{title}" ? Une
                fois supprimé, vous ne pourrez plus y accéder.
              </Box>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                textColor={"white"}
                bg="#FF0010"
                borderRadius={20}
                onClick={deleteCurrent}
                mr={3}
              >
                <Text fontSize={"14px"} fontFamily={"Sofia Pro"}>
                  SUPPRIMER L’EVENEMENT
                </Text>
              </Button>
              <Button
                borderRadius={20}
                color={"#0080FF"}
                bg={"white"}
                ref={cancelRef}
                onClick={onClose}
              >
                <Text fontSize={"14px"} fontFamily={"Sofia Pro"}>
                  Annuler
                </Text>
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}
